import React from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../../components/EmptyState';
import InlineAlert from '../../components/InlineAlert';

const PaymentPlans = () => {
  const navigate = useNavigate();
  return (
    <div className="row billing-panel" role="tabpanel" id="billing-panel-payment-plans" aria-labelledby="billing-tab-payment-plans" tabIndex={0} data-testid="billing-panel-payment-plans">
      <div className="col-12">
        <div className="card border-0 shadow-sm billing-surface-card billing-surface-card--feature">
          <div className="card-header bg-light border-0">
            <h5 className="card-title mb-0">
              <i className="bi bi-calendar-check me-2 text-info"></i>
              Payment Plans
            </h5>
          </div>
          <div className="card-body">
            <InlineAlert
              variant="info"
              icon="info-circle"
              title="Payment Plan Management"
              message="Set up and manage payment plans for customers with past due balances."
              className="border-0 mb-4"
            />
            <EmptyState
              icon="calendar-check"
              eyebrow="Payment Plans"
              title="No Customer Selected"
              message="Please search for and select a customer account to manage payment plans."
              compact
              actions={(
                <button
                  className="btn btn-outline-tse-primary"
                  onClick={() => navigate('../customer-lookup')}
                >
                  <i className="bi bi-search me-2"></i>Find Customer
                </button>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPlans;
